export const DOCUMENT_SEARCH_MAX_RANGE_DAYS = 60;
export const DOCUMENT_SEARCH_MAX_RESULTS = 500;
export const DOCUMENT_SEARCH_PAGE_SIZE = 25;
export const DOCUMENT_SEARCH_TITLE_MIN_LEN = 2;

export const DOCUMENT_STATUS_FILTER_OPTIONS = [
  { value: '', label: 'Qualquer status' },
  { value: 'DRAFT', label: 'Rascunho' },
  { value: 'MANUAL', label: 'Manual' },
  { value: 'PDF_GENERATED', label: 'PDF gerado' },
  { value: 'PDF_UPLOADED', label: 'PDF enviado (upload)' },
  { value: 'PENDING_SIGNATURE', label: 'Aguardando assinatura' },
  { value: 'SIGNED', label: 'Assinado por todos' },
  { value: 'ERROR', label: 'Erro' },
];

export const DOCUMENT_TYPE_FILTER_OPTIONS = [
  { value: '', label: 'Qualquer tipo' },
  { value: 'uploaded_signature', label: 'Documentos enviados (upload)' },
  { value: 'MANUAL', label: 'Somente documentos manuais' },
  { value: 'custom_template', label: 'Meus modelos (personalizado)' },
  { value: 'compromisso_compra_venda', label: 'Compromisso de Compra e Venda' },
  { value: 'contrato_locacao_imovel', label: 'Contrato de Locação de Imóvel' },
  { value: 'autorizacao_locacao_imovel', label: 'Autorização para Locação de Imóvel' },
  { value: 'proposta_compra_imovel', label: 'Proposta de Compra de Imóvel' },
  { value: 'contrato_parceria_vendas', label: 'Contrato de Parceria para Vendas' },
  { value: 'recibo_simples', label: 'Recibo Simples' },
  { value: 'autorizacao_gleba_loteamento', label: 'Autorização Gleba Loteamento' },
  { value: 'autorizacao_venda_imovel', label: 'Autorização para Venda de Imóvel' },
];

export function formatDateInputValue(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function defaultAdvancedSearchDateRange() {
  const end = new Date();
  const start = new Date();
  start.setDate(end.getDate() - 30);
  return {
    dateFrom: formatDateInputValue(start),
    dateTo: formatDateInputValue(end),
  };
}

export function validateAdvancedSearchForm(values) {
  const errors = {};
  const title = (values.title || '').trim();
  const status = (values.status || '').trim();
  const type = (values.type || '').trim();
  const dateFrom = (values.dateFrom || '').trim();
  const dateTo = (values.dateTo || '').trim();

  const hasAny =
    Boolean(title) ||
    Boolean(status) ||
    Boolean(type) ||
    Boolean(dateFrom) ||
    Boolean(dateTo);

  if (!hasAny) {
    errors.form = 'Informe ao menos um filtro.';
    return errors;
  }

  if (title && title.length < DOCUMENT_SEARCH_TITLE_MIN_LEN) {
    errors.title = `Use pelo menos ${DOCUMENT_SEARCH_TITLE_MIN_LEN} caracteres no nome.`;
  }

  const from = dateFrom ? new Date(`${dateFrom}T00:00:00`) : null;
  const to = dateTo ? new Date(`${dateTo}T23:59:59`) : null;

  if (dateFrom && Number.isNaN(from?.getTime())) {
    errors.dateFrom = 'Data inválida.';
  }
  if (dateTo && Number.isNaN(to?.getTime())) {
    errors.dateTo = 'Data inválida.';
  }

  if (from && to && from > to) {
    errors.dateTo = 'Data fim deve ser igual ou posterior à data início.';
  }

  if (from && to) {
    const diffMs = to.getTime() - from.getTime();
    const diffDays = diffMs / (1000 * 60 * 60 * 24);
    if (diffDays > DOCUMENT_SEARCH_MAX_RANGE_DAYS) {
      errors.dateTo = `Período máximo de ${DOCUMENT_SEARCH_MAX_RANGE_DAYS} dias.`;
    }
  }

  return errors;
}

export function buildAdvancedSearchQueryParams(criteria) {
  const params = {};
  if (criteria.dateFrom) params.date_from = criteria.dateFrom;
  if (criteria.dateTo) params.date_to = criteria.dateTo;
  if (criteria.status) params.status = criteria.status;
  if (criteria.type) params.type = criteria.type;
  if (criteria.title) params.title = criteria.title;
  if (criteria.source && criteria.source !== 'all') {
    params.source = criteria.source;
  }
  return params;
}
